// Categorie di destinatario per i messaggi WhatsApp preimpostati (Impostazioni Studio → Messaggi WhatsApp).
export const WA_CATEGORIES = [
  { key: "cliente", label: "Cliente" },
  { key: "controparte", label: "Controparte" },
  { key: "collaboratore_studio", label: "Collaboratore Studio" },
  { key: "istruttore", label: "Istruttore" },
  { key: "perito_compagnia", label: "Perito Compagnia" },
  { key: "collaboratore_professionista", label: "Collaboratore del Perito/Medico" },
  { key: "liquidatore", label: "Liquidatore" },
  { key: "accertatore", label: "Accertatore" },
  { key: "perito_parte", label: "Perito di Parte" },
  { key: "medico_legale", label: "Medico Legale" },
  { key: "riparatore", label: "Riparatore" },
  { key: "avvocato", label: "Avvocato / Legale incaricato" },
  { key: "ispettorato", label: "Ispettorato" },
  { key: "compagnia", label: "Compagnia" },
];

export const WA_PLACEHOLDERS = [
  "[saluto]", "[numero pratica]", "[cliente]", "[destinatario]", "[data sinistro]", "[numero polizza]", "[compagnia]",
  "[appuntamento]", "[data appuntamento]", "[ora appuntamento]", "[perito]", "[liquidatore]", "[ispettorato]", "[studio]",
];

export const waCategoryLabel = (k) => (WA_CATEGORIES.find((c) => c.key === k) || {}).label || k;

// Saluto in base all'ora di invio.
export const waSaluto = (d = new Date()) => {
  const h = d.getHours();
  if (h >= 6 && h < 13) return "Buongiorno";
  if (h >= 13 && h < 18) return "Buon pomeriggio";
  if (h >= 18 && h < 22) return "Buonasera";
  return "Buonanotte";
};

// Sostituisce i segnaposto; `extra` contiene i valori della pratica (chiavi = nome segnaposto senza parentesi).
export const fillWaTemplate = (text, { numero, cliente, destinatario, extra = {} }) => {
  const vals = { ...extra, "numero pratica": numero, cliente, destinatario, saluto: waSaluto() };
  return (text || "").replace(/\[([a-zà-ù ]+)\]/gi, (m, k) => {
    const key = k.trim().toLowerCase();
    return Object.prototype.hasOwnProperty.call(vals, key) ? (vals[key] || "") : m;
  });
};

// Inserisce `token` nella textarea nel punto del cursore e restituisce il nuovo testo.
export const insertAtCursor = (el, text, token) => {
  const s = el && typeof el.selectionStart === "number" ? el.selectionStart : (text || "").length;
  const e = el && typeof el.selectionEnd === "number" ? el.selectionEnd : s;
  const next = (text || "").slice(0, s) + token + (text || "").slice(e);
  if (el) requestAnimationFrame(() => { el.focus(); el.setSelectionRange(s + token.length, s + token.length); });
  return next;
};
